import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { PrefixUrlPipe } from '../../pipes/prefix-url.pipe';
import { prefixUrl } from '../../utils/url.util';

export type EventqAccentCheckboxVariant = 'motion' | 'human' | 'vehicle' | 'gun';

const TICK_ICONS: Record<EventqAccentCheckboxVariant, string> = {
  motion: '/assets/events/icons/checkbox-motion-tick.svg',
  human: '/assets/events/icons/checkbox-human-tick.svg',
  vehicle: '/assets/events/icons/checkbox-vehicle-tick.svg',
  gun: '/assets/events/icons/checkbox-gun-tick.svg',
};

@Component({
  selector: 'eventq-accent-checkbox',
  imports: [PrefixUrlPipe],
  templateUrl: './accent-checkbox.html',
  styleUrl: './accent-checkbox.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqAccentCheckbox {
  readonly label = input.required<string>();
  readonly variant = input<EventqAccentCheckboxVariant>('motion');
  readonly checked = input(true);

  readonly checkedChange = output<boolean>();

  readonly tickIconSrc = computed(() => prefixUrl(TICK_ICONS[this.variant()]));

  toggle(): void {
    this.checkedChange.emit(!this.checked());
  }
}
